import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { LayoutDashboard, CreditCard, FileText, Settings, Building, ShieldCheck, BarChart3 } from 'lucide-react';
export function MobileNav() {
  const {
    user
  } = useAuth();
  if (!user) return null;
  const getNavItems = () => {
    switch (user.role) {
      case 'tenant':
        return [{
          name: 'Home',
          icon: LayoutDashboard,
          path: '/tenant/dashboard'
        }, {
          name: 'Request',
          icon: FileText,
          path: '/tenant/rent-request'
        }, {
          name: 'Pay',
          icon: CreditCard,
          path: '/tenant/payment-schedule'
        }, {
          name: 'Settings',
          icon: Settings,
          path: '/tenant/settings'
        }];
      case 'landlord':
        return [{
          name: 'Home',
          icon: LayoutDashboard,
          path: '/landlord/dashboard'
        }, {
          name: 'Portfolio',
          icon: BarChart3,
          path: '/landlord/portfolio'
        }, {
          name: 'Properties',
          icon: Building,
          path: '/landlord/properties'
        }, {
          name: 'Settings',
          icon: Settings,
          path: '/tenant/settings'
        }];
      case 'admin':
        return [{
          name: 'Home',
          icon: LayoutDashboard,
          path: '/admin/dashboard'
        }, {
          name: 'Verify',
          icon: ShieldCheck,
          path: '/admin/verification'
        }, {
          name: 'Analytics',
          icon: BarChart3,
          path: '/admin/analytics'
        }, {
          name: 'Risk',
          icon: ShieldCheck,
          path: '/admin/risk-management'
        }];
      case 'employer':
        return [{
          name: 'Home',
          icon: LayoutDashboard,
          path: '/employer/dashboard'
        }];
      default:
        return [];
    }
  };
  const navItems = getNavItems();
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 pb-safe z-50" data-id="element-2407">
      <div className="flex justify-around items-center h-16" data-id="element-2408">
        {navItems.map(item => <NavLink key={item.path} to={item.path} className={({
        isActive
      }) => `flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-blue-600' : 'text-gray-500 hover:text-gray-900'}`} data-id="element-2409">
            <item.icon size={20} data-id="element-2410" />
            <span className="text-[10px] font-medium" data-id="element-2411">{item.name}</span>
          </NavLink>)}
      </div>
    </div>;
}